export default __webpack_public_path__ + "356be8edb5ea9267310b4c51c83dd4d0.jpg";